import axios from "axios";
import env from "../variables/EndpointEnvironment";

const ReportAPI = (props) => {
  return axios.get(
    `${env.HOST}/reports?cat=${props.cat}&from=${props.from}&to=${props.to}&orderBy=desc&limit=${props.limit}&page=${props.page}`,
    {
      headers: {
        "Content-Language": localStorage.getItem('i18nextLng'),
      },
    }
  );
};

export default ReportAPI;
